import {
  creditCard,
  fileCertificate,
  messageQuestion,
} from "@simplybusiness/icons";
import { Container, Icon, Text } from "@simplybusiness/mobius";

const BENEFITS = [
  {
    icon: creditCard,
    title: "Buy a policy online",
    description:
      "Get instant coverage today by paying all at once or choosing a payment plan, all 100% online.",
  },
  {
    icon: fileCertificate,
    title: "Instant certificate of insurance (COI)",
    description:
      "Once you purchase, we'll send your COI via email. You can also access it anytime in your customer account.",
  },
  {
    icon: messageQuestion,
    title: "Help after you purchase",
    description:
      "Have a question or need to make a change? No worries - we're here to help with anything you need.",
  },
];

export const InsuranceBenefits = () => {
  return (
    <div className="mobius-insurance-benefits">
      <Container size="sm" className="mobius-insurance-benefits__content">
        <Text elementType="h3" className="mobius-insurance-benefits__title">
          Online insurance made easy
        </Text>
        <ul className="mobius-insurance-benefits__list">
          {BENEFITS.map(({ icon, title, description }) => (
            <li key={title} className="mobius-insurance-benefits__item">
              <Icon
                icon={icon}
                size="md"
                className="mobius-insurance-benefits__item-icon"
              />
              <Text
                variant="h4"
                className="mobius-insurance-benefits__item-title"
              >
                {title}
              </Text>
              <Text className="mobius-insurance-benefits__item-description">
                {description}
              </Text>
            </li>
          ))}
        </ul>
      </Container>
    </div>
  );
};
